import { createStore } from 'vuex'
import global from './modules/global'

export const store = createStore ({
  strict: false,
  state: {
  },
  modules: {
    global
  },
  actions: {
  },
  mutations: {
  }
})